import { gql } from '@apollo/client';

export const WORKER_FIELDS = `
  id
  uuid
  login
  nickname
  phone
  roles {
    id
    title
    alias
  }
  last_name
  first_name
  middle_name
  dob
  last_worker_activity
  creator {
    id
    uuid
    last_name
    first_name
    nickname
  }
  created_at
  disabled_at
  banned_at
  avatar_url
  
`;

export const GET_ROLES = gql`
  query roles {
    roles {
      id
      alias
      permissions {
        id
        alias
      }
    }
  }
`;

export const SEARCH_WORKERS = gql`
  query workers($input: WorkersInput, $first: Int, $page: Int) {
    workers(input: $input, first: $first, page: $page) {
      paginatorInfo {
        count
        currentPage
      }
      data {
        ${WORKER_FIELDS}
      }
    }
  }
`;

export const WORKERS_PAGE_INFO = gql`
    query workers($workersInput: WorkersInput, $first: Int, $page: Int) {
      workers(input: $workersInput, first: $first, page: $page) {
        paginatorInfo {
          count
          currentPage
        }
        data {
          ${WORKER_FIELDS}
        }
      }
    }
`;

export const CREATE_WORKER = gql`
  mutation createWorker($input: CreateWorkerInput!) {
    createWorker(input: $input) {
      ${WORKER_FIELDS}
    }
  }
`;

export const UPDATE_WORKER = gql`
  mutation updateWorker($id: Int!, $input: UpdateWorkerInput!) {
    updateWorker(id: $id, input: $input) {
      ${WORKER_FIELDS}
    }
  }
`;

export const DELETE_WORKER = gql`
  mutation deleteWorker($id: Int!) {
    deleteWorker(id: $id) {
      uuid
      id
    }
  }
`;

export const COMPANY_PERMISSION = gql`
  query CompanyPermissions {
    companyPermissions {
      companyPermissions {
        role_id
        permissions {
          id
          locked
          enabled
          alias
          title
        }
      }
    }
  }
`;

export const UPDATE_COMPANY_PERMISSIONS = gql`
  mutation updateCompanyPermissions($input: UpdateCompanyPermissionsInput!) {
    updateCompanyPermissions(input: $input) {
      companyPermissions {
        permissions {
          alias
          enabled
          id
          locked
          title
        }
        role_id
      }
    }
  }
`;
